export const rubFacToColor = (rubFac: string): string => {
    switch (rubFac) {
        case 'VAC':
            return '#7A45E2';
        case 'RED':
        case 'RED2':
        case 'REI':
            return '#E5316E';
        case 'FRN':
        case 'FRS':
            return '#795548';
        case 'PUB':
        case 'PUBNS':
            return '#2962FF';
        default:
            return 'blueGrey.main';
    }
};

export const articleToColor = (
    articleFacturable: boolean,
    fMasqueCalcul: boolean,
    articleFacture: boolean,
): string => {
    if (fMasqueCalcul) {
        return '#ececec';
    }
    if (!articleFacturable && !articleFacture) {
        return '#f9e4d8';
    }
    return '#F6F7FA';
};

export const formatEuro = (
    amount: number,
    locale = 'fr-FR',
    currency = 'EUR',
    minMaxDecimals = 2,
): string =>
    amount.toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: minMaxDecimals,
        maximumFractionDigits: minMaxDecimals,
    });

export const dragHandleWidth = '35px';
export const rubriqueWidth = '100px';
export const quantiteWidth = '80px';
export const puWidth = '120px';
export const tauxWidth = '120px';
export const ttcWidth = '120px';
export const actionsWidth = '50px';
export const libelleWidth = `calc(100% - ${dragHandleWidth} - ${rubriqueWidth} - ${quantiteWidth} - ${puWidth} - ${tauxWidth} - ${ttcWidth} - ${actionsWidth})`;

export const libelleWidthMobile = `calc(100% - ${dragHandleWidth} - ${rubriqueWidth} )`;
export const quantiteWidthMobile = '15%';
export const puWidthMobile = '20%';
export const tauxWidthMobile = '20%';
export const ttcWidthMobile = '25%';
export const actionsWidthMobile = '10%';

export const rubriqueLibelle = 'Rub.';
export const quantiteLibelle = 'Qté';
export const puLibelle = 'PU';
export const tauxLibelle = 'TVA';
export const ttcLibelle = 'Total TTC';
export const libelleLibelle = `Libellé`;
